import React, { useState } from "react";
import styled from "styled-components";
import Illustration from "../../images/EmailDetails.png";
import { useForm } from "@formspree/react";

import emailImg from "../../images/EmailDetails.png";
import Plus from "../../icons/Plus.svg";

const StyledWrapper = styled.section`
  padding: 0 15%;

  .container-md,
  .container-fluid {
    background-color: #f9f9f9;
  }

  .container-md {
    border-radius: 16px;
  }

  h3 {
    margin-bottom: 1em;
  }

  input {
    border: none;
    background-color: #f4f5f7;
    padding: 0.5em 1em;
    border-radius: 5px 0 0 5px;
    width: 100%;
  }

  button {
    border: none;
    color: white;
    padding: 0.75em 4.5em;
    background-color: var(--orange);
    border-radius: 46px;
    flex-shrink: 0;
  }

  .inputContainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 420px;
  }

  @media (max-width: 992px) and (min-width: 768px) {
    img {
      width: 250px;
    }
  }

  @media (max-width: 768px) {
    padding: 0;
    margin-bottom: 0 !important;

    h3 {
      font-size: 28px;
    }

    .inputContainer {
      justify-content: center;
      padding: 0 5%;
    }

    input,
    button {
      font-size: 14px;
    }

    img {
      width: 40vw;
    }

    .mobileButton {
      margin: 2rem auto 0;
      font-size: 16px;
      border-radius: 50px;
      padding: 0.75em 2em;
    }
  }
`;

const PopUpWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .bg {
    position: absolute;
    z-index: 21;
    width: 100%;
    height: 100%;
    background-color: rgba(69, 69, 69, 0.7);
  }

  .container {
    position: relative;
    z-index: 22;
    background-color: #f9f9f9;
    max-width: 800px;
    width: 80vw;
    display: flex;
    flex-direction: column;
    padding: 128px 5rem 3rem;
    border-radius: 10px;
  }

  svg {
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
    transform: rotate(45deg);
  }

  .row {
    justify-content: center;
  }

  input {
    border: none;
    background-color: #f4f5f7;
    padding: 1em 1em;
    border-radius: 5px 0 0 5px;
    width: 100%;
  }

  img {
    width: 302px;
    height: 220px;
    position: absolute;
    top: -220px;
  }

  button {
    background-color: var(--orange);
    color: white;
    border: none;
    padding: 0.75em 4.5em;
    border-radius: 50px;
  }

  @media (max-width: 768px) and (min-width: 578px) {
    h3 {
      font-size: 28px;
    }
    button {
      padding: 0.5em 2.5em;
    }
  }

  @media (max-width: 576px) {
    background-color: rgba(69, 69, 69, 0.7);
    .container {
      width: 90vw;
      padding: 64px 2rem 1.5rem;
    }
    h3 {
      font-size: 16px;
    }
    img {
      width: 170px;
      height: 110px;
      top: -110px;
    }
    input {
      padding: 0.75em 0.75em;
    }
    button {
      width: max-content;
      padding: 0.5em 2.5em;
    }
  }
`;

const EmailDetails = () => {
  const [popUpOpen, setPopUpOpen] = useState(false);

  const PopUp = () => {
    const [state, handleSubmit] = useForm("xoqyrkzo");

    return (
      <PopUpWrapper>
        <div className="bg" onClick={() => setPopUpOpen(false)}></div>
        <div className="container position-relative">
          <Plus onClick={() => setPopUpOpen(false)} />
          <div className="row position-relative">
            <img src={emailImg} alt="" />
          </div>
          {!state.succeeded ? (
            <>
              <div className="row my-md-5 my-4">
                <h3 className="text-center col-lg-10">
                  Are you ready to take advantage of fintech?
                </h3>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row mb-md-5 mb-4">
                  <input
                    id="email"
                    name="Email"
                    type="email"
                    placeholder="Your email address"
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    required
                  />
                </div>
                <div className="row">
                  <button
                    className="col-lg-5 col-sm-7"
                    disabled={state.submitting ? true : false}
                  >
                    Find out more
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="row text-center my-md-5 my-4">
              <h3>Thank you for reaching out!</h3>
            </div>
          )}
        </div>
      </PopUpWrapper>
    );
  };

  return (
    <>
      <StyledWrapper>
        <div className="container-md container-fluid py-5">
          <div className="row justify-content-evenly align-items-center">
            <div className="col-lg-3 d-flex justify-content-center mb-lg-0 mb-5">
              <img
                src={Illustration}
                alt=""
                className="img-fluid align-self-center"
              />
            </div>
            <div className="col-lg-6">
              <>
                <h3 className="text-lg-start text-center">
                  Are you ready to take advantage of fintech?
                </h3>
                <div className="inputContainer mx-lg-0 mx-auto">
                  <button
                    className="d-md-block d-none"
                    onClick={() => setPopUpOpen(true)}
                  >
                    Get Started
                  </button>
                </div>
                <button
                  className="d-md-none d-block mobileButton"
                  onClick={() => setPopUpOpen(true)}
                >
                  Get Started
                </button>
              </>
            </div>
          </div>
        </div>
      </StyledWrapper>
      {popUpOpen && <PopUp />}
    </>
  );
};

export default EmailDetails;
